import Papa from 'papaparse';
// import ComplementDB from '../../database/wrappers/complement';
class ImportInsumeCsv {
	constructor(
		private readonly estabId: string,
		private readonly storeId: string
	) { }

	async import(file: any) {
		const array = await this.startReaderFile(file);
		this.validateData(array);
		return;
		// new ComplementDB(this.estabId).writeBatch(array)
	}

	private startReaderFile(file: any): Promise<any> {
		return new Promise((res) => {
			const reader = new FileReader();
			reader.onload = function () {
				ImportInsumeCsv.readCSV(reader.result, res);
			};
			reader.readAsText(file);
		});
	}

	private static readCSV(csv: any, fn: any) {
		const results = Papa.parse(csv, { header: true, delimiter: ';' });
		const rows = results.data;
		const datas: any[] = [];

		rows.forEach((row: any) => {
			const formatedRow = this.__convertKeys(row);
			if (!formatedRow.id) return;

			const qtd = Number(formatedRow.qtd);
			const price = Number(
				String(formatedRow.price).replace(/[^\d,]/g, '').replace(',', '.')
			);

			const numericQtd = isNaN(qtd) ? null : qtd;
			const numericPrice = isNaN(price) ? null : Math.round(price * 100);

			const validQtd = typeof numericQtd === 'number' && numericQtd > 0;
			const validPrice = typeof numericPrice === 'number' && numericPrice > 0;

			if (validQtd && validPrice) {
				datas.push({
					id: formatedRow.id,
					name: formatedRow.name,
					unit: formatedRow.unit,
					qtd: numericQtd,
					price: numericPrice,
				});
			}
		});

		fn(datas);
	}


	private validateData(datas: any[]) {
		datas.forEach((item) => {
			if (!item.id) throw `${item.id}, Campo id ausente`;
			if (!item.name) throw `${item.name}, Campo name ausente`;
			if (!item.unit) throw `${item.unit}, Campo unit ausente`;
			if (item.qtd === null || isNaN(item.qtd)) throw `${item.name}, Campo qtd inválido`;
			if (item.price === null || isNaN(item.price)) throw `${item.name}, Campo price inválido`;
		});
	}

	private static __convertKeys(inputObject: any) {
		if (inputObject.id) return inputObject;
		const keyMapping: Record<string, string> = {
			ID: 'id',
			NOME: 'name',
			UNIDADE: 'unit',
			QUANTIDADE: 'qtd',
			PREÇO: 'price',
		};

		const outputObject: Record<string, any> = {};
		for (const key in inputObject) {
			if (keyMapping[key]) {
				outputObject[keyMapping[key]] = inputObject[key];
			}
		}
		return outputObject;
	}
}

export default ImportInsumeCsv;
